// src/components/admin/design/HeroBannerPreview.tsx
"use client";

import React from "react";
import HeroBannerSectionRenderer from "@/components/store/sections/hero-banner";
import { useDetectedAdminTheme } from "./UniversalProductCardPreview";

export interface HeroBannerPreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
}

export default function HeroBannerPreview({
  variantId = "brush_split",
  primaryColor = "#059669",
  theme: propTheme,
}: HeroBannerPreviewProps) {
  const [activeTheme] = useDetectedAdminTheme(propTheme);
  const isLight = activeTheme === "light";

  return (
    <div
      data-xylo-preview-theme={activeTheme}
      className={`w-full overflow-hidden rounded-2xl p-2 transition-colors ${
        isLight ? "bg-transparent text-slate-900" : "bg-transparent text-slate-100 dark"
      }`}
    >
      <HeroBannerSectionRenderer
        variant={variantId}
        primaryColor={primaryColor}
        banners={[
          {
            id: 1,
            badge_title: "SEASON LAUNCH • UP TO 50% OFF",
            title: "Elevate Your Everyday Lifestyle & Fashion",
            subtitle:
              "Curated premium collections with express nationwide delivery and 100% authenticity guarantee.",
            button_text: "Explore Collection",
            target_url: "/products",
            image:
              "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&auto=format&fit=crop&q=80",
          },
        ]}
      />
    </div>
  );
}